import { render } from "./baseCollapse.vue?vue&type=template&id=153a5ede"
import script from "./baseCollapse.vue?vue&type=script&lang=js"
export * from "./baseCollapse.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__